import React from 'react';
import {req_promoter_photo_category, req_promoter_photo_category_status} from '../../../../Helper/Constants';
import ManagedListSection from './ManagedListSection';

export default function PromoterCategorySection(props) {
    const {language} = props;
    return (
        <ManagedListSection
            {...props}
            endpoint={req_promoter_photo_category}
            statusEndpoint={req_promoter_photo_category_status}
            idField="type_id"
            nameField="type_name"
            statusField="type_status"
            dialogTitle={language.new_photo_category || language.add}
            fieldLabel={language.category_name}
            validationMessage={language.category_name}
        />
    );
}
